export const UserControllerFactory = ({
  userService,
}: {
  userService: IUserService;
}) => {
  const getUserBetaFeatures: IGetUserBetaFeaturesController = async () => {
    const userBetaFeature = await userService.getUserBetaFeatures();
    return userBetaFeature;
  };

  const updateUserInfo: IUpdateUserInfoController = async (payload) => {
    const userInfo = await userService.updateUserInfo(payload);
    return userInfo;
  };

  const signupUser: ISignupUserController = async (payload) => {
    const user = await userService.signupUser(payload);
    return user;
  };

  const autoBedExit: IAutoBedExitController = async (payload) => {
    const result = await userService.autoBedExit(payload);
    return result;
  };

  return {
    getUserBetaFeatures,
    updateUserInfo,
    signupUser,
    autoBedExit,
  };
};
